import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-organization',
  templateUrl: './organization.component.html',
  styleUrls: ['./organization.component.less']
})
export class OrganizationComponent implements OnInit {
  isCollapsed = false;
  constructor() { }
  nodes: any = [
    {
      name: 'Hội đồng trường',
      cssClass: 'ngx-org-ceo',
      image: '../../../assets/images/icons/photo.png',
      title: '',
      childs: [
        {
          name: 'Ban giám hiệu',
          cssClass: 'ngx-org-ceo',
          image: '../../../assets/images/icons/photo.png',
          title: '',
          childs: [
            {
              name: 'Phòng ban',
              image: '../../../assets/images/icons/photo.png',
              title: '',
              childs: [
                {
                  name: 'Phòng Tổ chức - Hành chính',
                  image: '../../../assets/images/icons/photo.png',
                  title: '',
                },
                {
                  name: 'Phòng Quản lý Đào tạo',
                  image: '../../../assets/images/icons/photo.png',
                  title: '',
                },
                {
                  name: 'Phòng Tài chính - Kế toán',
                  image: '../../../assets/images/icons/photo.png',
                  title: '',
                },
                {
                  name: 'Phòng Quản lý khoa học',
                  image: '../../../assets/images/icons/photo.png',
                  title: 'và Hợp tác quốc tế',
                },
                {
                  name: 'Phòng Khảo thí',
                  image: '../../../assets/images/icons/photo.png',
                  title: 'và Bảo đảm chất lượng',
                },
                {
                  name: 'Phòng Truyền thông và Tuyển sinh',
                  image: '../../../assets/images/icons/photo.png',
                  title: '',
                },
                {
                  name: 'Phòng Công tác sinh viên',
                  image: '../../../assets/images/icons/photo.png',
                  title: 'và Hợp tác doanh nghiệp',
                },
                {
                  name: 'Phòng Quản lý Cơ sở vật chất',
                  image: '../../../assets/images/icons/photo.png',
                  title: 'và Thiết bị',
                },
                {
                  name: 'Ban Công nghệ thông tin',
                  image: '../../../assets/images/icons/photo.png',
                  title: '',
                },
                {
                  name: 'Thư viện',
                  image: '../../../assets/images/icons/photo.png',
                  title: '',
                },
                {
                  name: 'Ban Thanh tra - Pháp chế',
                  image: '../../../assets/images/icons/photo.png',
                  title: '',
                },
              ]
            },
            {
              name: 'Khoa',
              image: '../../../assets/images/icons/photo.png',
              title: '',
              childs: [
                {
                  name: 'Khoa nhân văn và ngôn ngữ',
                  image: '../../../assets/images/icons/photo.png',
                  title: '',
                  childs: []
                },
                {
                  name: 'Khoa kinh tế',
                  image: '../../../assets/images/icons/photo.png',
                  title: '',
                  childs: []
                },
                {
                  name: 'Khoa công nghệ sinh học',
                  image: '../../../assets/images/icons/photo.png',
                  title: '',
                  childs: []
                },
                {
                  name: 'Khoa kỹ thuật',
                  image: '../../../assets/images/icons/photo.png',
                  title: '',
                  childs: []
                },
                {
                  name: 'Khoa Y',
                  image: '../../../assets/images/icons/photo.png',
                  title: '',
                  childs: []
                },
                           
              ]
            },
            {
              name: 'Đoàn thể',
              image: '../../../assets/images/icons/photo.png',
              title: '',
              childs: [
                {
                  name: 'Công đoàn',
                  image: '../../../assets/images/icons/photo.png',
                  title: '',
                  childs: []
                }
              ]
            },
            {
              name: 'Đơn vị trực thuộc',
              image: '../../../assets/images/icons/photo.png',
              title: '',
              childs: [
                {
                  name: 'Trường THPT Năng Khiếu ĐH Tân Tạo',
                  image: '../../../assets/images/icons/photo.png',
                  title: '',
                },
                {
                  name: 'Trường TH và THCS tư thục Tân Tạo',
                  image: '../../../assets/images/icons/photo.png',
                  title: '',
                },
                {
                  name: 'Trường Mầm Non Mặt Trời Đỏ',
                  image: '../../../assets/images/icons/photo.png',
                  title: '',
                }
              ]
            },
            {
              name: 'Trung tâm',
              image: '../../../assets/images/icons/photo.png',
              title: '',
              childs: [
                {
                  name: 'Trung tâm Khởi nghiệp ĐH Tân Tạo',
                  image: '../../../assets/images/icons/photo.png',
                  title: '',
                },
                {
                  name: 'Trung tâm Ngoại ngữ ĐH Tân Tạo',
                  image: '../../../assets/images/icons/photo.png',
                  title: '',
                }
              ]
            }
          ]
        },
      ]
    }

  ];
  itemClick($event:any){
    console.log("item click", $event)
  }
  ngOnInit() {
  }

}
